import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import Nav from "./Nav";
import MobileMenu from "./MobileMenu";
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";

const HeaderOne = ({
  btnStyle,
  HeaderStyle,
  hideBuyButton = true,
  hideThemeButton = false,
}) => {
  const [ofcanvasShow, setOffcanvasShow] = useState(false);
  const onCanvasHandler = () => {
    setOffcanvasShow((prev) => !prev);
  };

  const sticky = useStickyHeader(50);
  const headerClasses = `header-default ${sticky ? "sticky" : ""}`;

  return (
    <>
      <header
        className={`rn-header header-default ${HeaderStyle} ${headerClasses}`}
      >
        <div className="container position-relative">
          <div className="row align-items-center row--0">
            <div className="col-lg-3 col-md-6 col-4">
              <Logo
                image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                image2={`${process.env.PUBLIC_URL}/images/logo/logo-dark.png`}
              />
            </div>
            <div className="col-lg-9 col-md-6 col-8 position-static">
              <div className="header-right">
                <nav className="mainmenu-nav d-none d-lg-block">
                  <Nav />
                </nav>
                {!hideBuyButton && (
                  <div className="header-btn">
                    <a
                      className={`btn-default ${btnStyle}`}
                      target="_blank"
                      href="https://themeforest.net/checkout/from_item/33571911?license=regular"
                    >
                      BUY NOW
                    </a>
                  </div>
                )}
                <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                  <div className="hamburger">
                    <span
                      className="hamburger-button"
                      onClick={onCanvasHandler}
                    >
                      <FiMenu />
                    </span>
                  </div>
                </div>
                {!hideThemeButton && <Darkmode />}
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler} />
    </>
  );
};
export default HeaderOne;
